import Cookies from 'js-cookie';
import Main from '../_modules/main';

class PopUp {
    constructor() {
        this.components = document.querySelectorAll('.m-pop-up');
        this.Main = new Main();
        // this.lenis = lenis;
        this.previousActiveElement;

        if (this.components) {
            this.components.forEach((component) => {
                this.init(component);
            });
        }
    }

    init(component) {
        const self = this;
        const closeTriggers = component.querySelectorAll('.js-pop-up-close');
        const popUpState = Cookies.get('ciwc-pop-up');

        closeTriggers.forEach((trigger) => {
            trigger.addEventListener('click', function () {
                self.closePopUp();
            });
        });

        if (popUpState != 'closed') {
            setTimeout(function () {
                self.openPopUp(component);
            }, 1000);
        }
    }

    closePopUp() {
        const self = this;
        const popUp = document.querySelector('.m-pop-up.is-active');

        if (popUp) {
            const inFifteenMinutes = new Date(
                new Date().getTime() + 5 * 60 * 1000
            );

            Cookies.set('ciwc-pop-up', 'closed', {
                expires: inFifteenMinutes,
            });

            popUp.classList.remove('is-active');

            self.previousActiveElement.focus();
        }

        self.Main.unlockScroll();
        // self.lenis.start();
    }

    openPopUp(popUp) {
        const self = this;

        self.Main.lockScroll();
        // self.lenis.stop();

        // Store current focused element
        self.previousActiveElement = document.activeElement;

        // Listen for keyboard
        popUp.addEventListener('keydown', addKeyboardListeners);

        // Find all focusable children
        const focusableElementsString =
            'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        let focusableElements = popUp.querySelectorAll(focusableElementsString);

        focusableElements = Array.prototype.slice.call(focusableElements);

        let firstFocusableElement = focusableElements[0];
        let lastFocusableElement =
            focusableElements[focusableElements.length - 1];

        popUp.classList.add('is-active');

        // Focus on first element in popUp
        firstFocusableElement.focus();

        function addKeyboardListeners(event) {
            if (event.keyCode === 9) {
                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        event.preventDefault();
                        lastFocusableElement.focus();
                    }
                } else {
                    if (document.activeElement === lastFocusableElement) {
                        event.preventDefault();
                        firstFocusableElement.focus();
                    }
                }
            }

            if (event.keyCode === 27) {
                self.closePopUp();
            }
        }
    }
}

export default PopUp;
